export const iconFontAwesomeCampingCaravan = (
	<i className="fa-solid fa-caravan"></i>
);
